import { persistStore, persistCombineReducers } from 'redux-persist';
import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import config from '@config';
import { reducer as globals } from '@redux/globals';
import reducers from '@redux-core/reducers';

/**
 * Function to patchReducer and apply
 * globals actions reducer
 *
 * @param {Function} appReducer
 */
const patchReducer = (appReducer) => (state, action) => (appReducer(globals(state, action), action));

export default (history, msalInstance) => {
	const middleware = [];
	const enhancers = [];

	// Apply router middleware
	middleware.push(routerMiddleware(history));

	// Apply thunks middleware
	middleware.push(thunk.withExtraArgument({ msalInstance }));

	// Apply all middlewares
	enhancers.push(applyMiddleware(...middleware));

	const appropriateCompose = config.debugSettings.useReduxDevTools ? composeWithDevTools({
		name       : config.app.displayName,
		realtime   : true,
		trace      : true,
		traceLimit : 25,
	}) : compose;

	// Create app reducer
	const appReducer = persistCombineReducers(config.reduxPersist, reducers);

	// Create Store
	const store = createStore(patchReducer(appReducer), appropriateCompose(...enhancers));

	// Create Persistor
	const persistor = persistStore(store, null);

	return { store, persistor };
};
